<div class="title-section">
    <div class="title-container">
        <h2 class="title-h2">
            {{ 'ancillaries.bundlesCard.title' | ibeadmin | async }}
        </h2>
        <app-svg *ngIf="added"  svg="sprite.svg#flight--brand-checked"  class="added-icon" aria-hidden=true  [alt]="'Checked icon'">
        </app-svg>
    </div>
    
    <div>
        <div *ngFor="let feature of INDRA_getPackFeatures(pack)" class="service-container">
            <app-svg aria-hidden="true" [ngClass]="['extras-feature__icon']"
                svg="icons.svg#{{INDRA_getFeatureIcon(feature) || 'general--plus'}}" tooltip="{{feature.code}}"
                [alt]="feature.code + ' icon'"></app-svg>
            <span>{{INDRA_getFeatureLabel(feature)}}</span>
        </div>
    </div>
</div>

<div class="action-section">
    <div class="price-section">
        <h3 class="title-h3">
            <span *ngIf="this.pack.length > 1 && !flightBased">    
                {{ 'bookingDetails.label.from' | ibeadmin | async }}
            </span>
            {{INDRA_getAndFormatCash() | indracurrency:itemsCurrencyCode}}
        </h3>
        <span>{{ 'ancillaries.bundlesCard.perPassenger' | ibeadmin | async }}</span>
    </div>
    <div>
        <button *ngIf="!added || fromModal" (click)="INDRA_handleOpenPack()" [disabled]="disable"
            class="button button--small extras-feature__button add-feature"
            [attr.aria-label]="INDRA_getPackName(pack)">
            <span>{{ 'ancillaries.bundlesCard.add' | ibeadmin | async }}</span>
        </button>

        <!-- Edit Buttons Desktop/Mobile -->
        <button
            *ngIf="added && !fromModal"
            (click)="INDRA_removeBundle()"
            class="button button-tonal-tertiary remove-feature"
            [attr.aria-label]="INDRA_getPackName(pack)"
            style="text-align: center"
        >
            <span>{{ 'ancillaries.bundlesCard.remove' | ibeadmin | async }}</span>
        </button>
    </div>
</div>